import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  knowledgeAuthContinueStorageKey,
  parseKnowledgeAuthContinueParams,
} from "utils/knowledgeAuthContinue";

/**
 * Persist Knowledge handoff query params before SignInForm gates children.
 */
export function PersistKnowledgeAuthContinueParams() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params = parseKnowledgeAuthContinueParams({
      returnTo: searchParams.get("return_to"),
      state: searchParams.get("state"),
      knowledgeOrigin: searchParams.get("knowledge_origin"),
    });
    if (params == null) {
      return;
    }
    try {
      sessionStorage.setItem(knowledgeAuthContinueStorageKey(), JSON.stringify(params));
    } catch {
      // ignore quota / private mode
    }
  }, [searchParams]);

  return null;
}
